"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ol = require("openlayers");
const _ = require("lodash");
const proj4defs_1 = require("../logic/proj4defs");
require("openlayers/css/ol.css");
require("./MapView.less");
const LayerSelector_1 = require("../components/LayerSelector");
const layers_1 = require("../logic/layers");
const layers_2 = require("./layers");
const areaSelector_1 = require("./areaSelector");
const url_parameters_1 = require("../logic/url-parameters");
const proj4defs_2 = require("../logic/proj4defs");
const dragFeatures_1 = require("./dragFeatures");
const enumValues_1 = require("../logic/enumValues");
const Select_1 = require("../components/Select");
const mapScale_1 = require("./mapScale");
const MapScaleSelector_1 = require("./MapScaleSelector");
const utmArea_1 = require("./utmArea");
ol.proj.setProj4(proj4defs_1.setupProjections());
class MapView extends React.Component {
    constructor() {
        super();
        this.selectionLayer = new ol.source.Vector();
        this.areaSelectorInteraction = areaSelector_1.createAreaSelector(this.selectionLayer, () => this.state.orientation, selection => this.setState({ selection }), () => this.setAreaDragMode());
        this.dragInteraction = new dragFeatures_1.Drag();
        this.state = {
            selection: undefined,
            orientation: areaSelector_1.Orientation.LANDSCAPE,
            source: 'topo',
            margin: 10,
            z: 9
        };
        this.dragInteraction.on('moveend', event => {
            const geom = event.feature.getGeometry();
            if (geom instanceof ol.geom.Polygon) {
                this.setState({ selection: areaSelector_1.toMapSelection(geom) });
            }
        });
    }
    setAreaDragMode() {
        this.map.removeInteraction(this.areaSelectorInteraction);
        this.map.addInteraction(this.dragInteraction);
    }
    setAreaDrawMode() {
        this.map.removeInteraction(this.dragInteraction);
        this.map.addInteraction(this.areaSelectorInteraction);
    }
    createMap() {
        return new ol.Map({
            target: 'map',
            controls: ol.control.defaults().extend([
                new ol.control.MousePosition({
                    coordinateFormat: formatToMGRS,
                    projection: proj4defs_2.WGS84
                }),
                new ol.control.ScaleLine(),
                new ol.control.ZoomSlider()
            ]),
            layers: layers_2.createLayers(this.selectionLayer),
            view: new ol.View({
                center: ol.proj.transform([21.03, 52.22], proj4defs_2.WGS84, proj4defs_2.WEB_MERCATOR),
                zoom: 10
            }),
            interactions: ol.interaction.defaults().extend([
                this.areaSelectorInteraction
            ])
        });
    }
    updateSelectionFromUrlParams() {
        this.setSelection(url_parameters_1.urlParamsToMapArea());
    }
    componentDidMount() {
        this.map = this.createMap();
        this.updateSelectionFromUrlParams();
    }
    componentDidUpdate(prevProps, prevState) {
        window.history.replaceState(undefined, undefined, '?' + url_parameters_1.mapAreaToUrlParams(this.state.selection));
    }
    setSelection(selection) {
        if (selection === undefined) {
            this.setAreaDrawMode();
        }
        else {
            this.setAreaDragMode();
        }
        this.selectionLayer.clear();
        if (_.isEmpty(selection)) {
            return;
        }
        this.setState({ selection });
        const geometry = utmArea_1.getUTMAreaBox({ area: selection, getAspectRatioOrientation: () => this.state.orientation });
        const feature = new ol.Feature({ geometry });
        this.selectionLayer.addFeature(feature);
    }
    getScale(pageType) {
        const { orientation, margin, selection } = this.state;
        if (orientation === areaSelector_1.Orientation.NONE || selection === undefined) {
            return;
        }
        return mapScale_1.getScale({
            selection,
            pageType,
            orientation,
            margin,
        });
    }
    setScale(scale, pageType) {
        const { orientation, margin, selection } = this.state;
        this.setSelection(mapScale_1.getSelectionForScale({
            scale,
            selection,
            pageType,
            orientation,
            margin,
        }));
    }
    getFetchParams() {
        return url_parameters_1.mapAreaToUrlParams(this.state.selection) + ':' + [
            this.state.source,
            this.state.z,
        ].join('-');
    }
    render() {
        return React.createElement("div", { className: "MapView" },
            React.createElement("div", { className: "panel" },
                React.createElement(LayerSelector_1.LayerSelector, { layers: layers_1.LAYERS, onChange: value => this.setState(value) }),
                React.createElement(Select_1.Select, { values: enumValues_1.enumMap(areaSelector_1.Orientation), value: this.state.orientation.toString(), onChange: (value) => this.setState({ orientation: Number(value) }) }),
                this.state.orientation !== areaSelector_1.Orientation.NONE && React.createElement(MapScaleSelector_1.MapScaleSelector, { margin: this.state.margin, onMarginChange: margin => this.setState({ margin }), getScale: pageType => this.getScale(pageType), onScaleChange: (scale, pageType) => this.setScale(scale, pageType) }),
                this.state.selection && React.createElement("a", { className: "button", target: "printable", href: `fetch.html?${this.getFetchParams()}` }, "Mapa"),
                React.createElement("a", { className: "button", onClick: () => {
                        this.setState({ selection: undefined });
                        this.setSelection(undefined);
                    } }, "Reset")),
            React.createElement("div", { id: "map", style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 0
                } }));
    }
}
exports.MapView = MapView;
function formatToMGRS(pos) {
    const mgrs = proj4defs_2.ll2mgrs(pos);
    return `${mgrs.zone} ${mgrs.grid} ${mgrs.x} ${mgrs.y}`;
}



//////////////////
// WEBPACK FOOTER
// ./src/map/MapView.tsx
// module id = 289
// module chunks = 0